export enum SystemLanguage {
  English = 'en',
  Danish = 'da',
  Arabic = 'ar',
  French = 'fr',
}
